/*
    BEEP BOP BOOP - I AM AN AUTO GENERATED FILE - DO NOT EDIT ME MANUALLY
*/


// Name: Yardi JSON Schemas 

const _YARDI_SCREENING_WORKS_PRO_XML_JSON_SCHEMA = {
    "$ref": "#/definitions/YardiScreeningWorksProXMLSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "YardiScreeningWorksProXMLSchema": {
            "additionalProperties": false,
            "properties": {
                "admin_error_message": {
                    "maxLength": 1024,
                    "title": "Admin Error Message",
                    "type": "string"
                },
                "created_deposit_group_uid": {
                    "reference_type": "uuid",
                    "title": "Created Deposit Group Uid",
                    "type": "string",
                    "uid_resource_type": "deposit_group"
                },
                "created_deposit_uids": {
                    "items": {
                        "title": "created_deposit_uids",
                        "type": "string"
                    },
                    "reference_type": "uuid",
                    "title": "Created Deposit Uids",
                    "type": "array",
                    "uid_resource_type": "deposit"
                },
                "created_pmc_account_uid": {
                    "reference_type": "uuid",
                    "title": "Created Pmc Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "created_tenant_account_uids": {
                    "items": {
                        "title": "created_tenant_account_uids",
                        "type": "string"
                    },
                    "reference_type": "uuid",
                    "title": "Created Tenant Account Uids",
                    "type": "array",
                    "uid_resource_type": "user_account"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "deposify_tags": {
                    "items": {
                        "format": "integer",
                        "title": "deposify_tags",
                        "type": "number"
                    },
                    "title": "Deposify Tags",
                    "type": "array"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "notes_uid": {
                    "reference_type": "uuid",
                    "title": "Notes Uid",
                    "type": "string",
                    "uid_resource_type": "resource_note"
                },
                "permanent_link_uid": {
                    "reference_type": "uuid",
                    "title": "Permanent Link Uid",
                    "type": "string",
                    "uid_resource_type": "permanent_link"
                },
                "pmc_email_hashes": {
                    "items": {
                        "title": "pmc_email_hashes",
                        "type": "string"
                    },
                    "title": "Pmc Email Hashes",
                    "type": "array"
                },
                "processing_completed_timestamp": {
                    "format": "date-time",
                    "title": "Processing Completed Timestamp",
                    "type": "string"
                },
                "state": {
                    "class_name": "YardiScreeningWorksProXMLState",
                    "enum": [
                        "awaiting_processing",
                        "processed",
                        "has_errors"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "xml_data": {
                    "title": "Xml Data",
                    "type": "string"
                },
                "xml_uid": {
                    "reference_type": "uuid",
                    "title": "Xml Uid",
                    "type": "string",
                    "uid_resource_type": "yardi_screening_works_pro_xml"
                }
            },
            "required": [
                "created_deposit_group_uid",
                "created_deposit_uids",
                "created_pmc_account_uid",
                "created_tenant_account_uids",
                "permanent_link_uid",
                "pmc_email_hashes",
                "processing_completed_timestamp",
                "state",
                "xml_data",
                "xml_uid"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _YARDI_VOYAGER_ACTIVE_SCAN_LOG_ENTRY_JSON_SCHEMA = {
    "$ref": "#/definitions/YardiVoyagerActiveScanLogEntrySchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "YardiVoyagerActiveScanLogEntrySchema": {
            "additionalProperties": false,
            "properties": {
                "completed_steps_json": {
                    "additionalProperties": {},
                    "title": "Completed Steps Json",
                    "type": "object"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "delete_after_timestamp": {
                    "format": "date-time",
                    "title": "Delete After Timestamp",
                    "type": "string"
                },
                "deposify_pmc_account_uid": {
                    "reference_type": "uuid",
                    "title": "Deposify Pmc Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "deposify_tags": {
                    "items": {
                        "format": "integer",
                        "title": "deposify_tags",
                        "type": "number"
                    },
                    "title": "Deposify Tags",
                    "type": "array"
                },
                "do_not_delete": {
                    "title": "Do Not Delete",
                    "type": "boolean"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "log_uid": {
                    "reference_type": "uuid",
                    "title": "Log Uid",
                    "type": "string",
                    "uid_resource_type": "yardi_voyager_active_scan_log_entry"
                },
                "notes_uid": {
                    "reference_type": "uuid",
                    "title": "Notes Uid",
                    "type": "string",
                    "uid_resource_type": "resource_note"
                },
                "scan_end_timestamp": {
                    "format": "date-time",
                    "title": "Scan End Timestamp",
                    "type": "string"
                },
                "scan_start_timestamp": {
                    "format": "date-time",
                    "title": "Scan Start Timestamp",
                    "type": "string"
                },
                "scan_type": {
                    "class_name": "YardiVoyagerScanType",
                    "enum": [
                        "full_pmc_scan",
                        "property_configurations",
                        "unit_information",
                        "ils_guest_card_activity",
                        "get_tenant_status",
                        "all_active_pmc_full_scan",
                        "property_resident_processing"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "state": {
                    "class_name": "YardiVoyagerScanState",
                    "enum": [
                        "active",
                        "success",
                        "failure"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "version": {
                    "maxLength": 10,
                    "minLength": 1,
                    "title": "Version",
                    "type": "string"
                },
                "voyager_property_uid": {
                    "reference_type": "uuid",
                    "title": "Voyager Property Uid",
                    "type": "string",
                    "uid_resource_type": "yardi_voyager_property"
                },
                "voyager_property_unit_uid": {
                    "reference_type": "uuid",
                    "title": "Voyager Property Unit Uid",
                    "type": "string",
                    "uid_resource_type": "yardi_voyager_property_unit"
                }
            },
            "required": [
                "completed_steps_json",
                "delete_after_timestamp",
                "deposify_pmc_account_uid",
                "do_not_delete",
                "log_uid",
                "scan_end_timestamp",
                "scan_start_timestamp",
                "scan_type",
                "state",
                "version",
                "voyager_property_uid",
                "voyager_property_unit_uid"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _YARDI_VOYAGER_CHARGE_JSON_SCHEMA = {
    "$ref": "#/definitions/YardiVoyagerChargeSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "YardiVoyagerChargeSchema": {
            "additionalProperties": false,
            "properties": {
                "admin_error_info": {
                    "title": "Admin Error Info",
                    "type": "string"
                },
                "charge_amount_in_cents": {
                    "cents_value": true,
                    "format": "integer",
                    "maximum": 9223372036854775807,
                    "minimum": 0,
                    "title": "Charge Amount In Cents",
                    "type": "number"
                },
                "charge_code_string": {
                    "maxLength": 8,
                    "title": "Charge Code String",
                    "type": "string"
                },
                "charge_code_uid": {
                    "reference_type": "uuid",
                    "title": "Charge Code Uid",
                    "type": "string",
                    "uid_resource_type": "yardi_voyager_charge_code"
                },
                "charge_comments": {
                    "title": "Charge Comments",
                    "type": "string"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "deposify_pmc_account_uid": {
                    "reference_type": "uuid",
                    "title": "Deposify Pmc Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "deposify_tags": {
                    "items": {
                        "format": "integer",
                        "title": "deposify_tags",
                        "type": "number"
                    },
                    "title": "Deposify Tags",
                    "type": "array"
                },
                "intent_type": {
                    "class_name": "YardiVoyagerChargeCodeIntent",
                    "enum": [
                        "deposify_security_deposit",
                        "deposify_pet_deposit",
                        "deposify_utility_deposit",
                        "deposify_close_deposit",
                        "deposify_withhold_deposit_funds"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "intent_uid": {
                    "title": "Intent Uid",
                    "type": "string"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "notes_uid": {
                    "reference_type": "uuid",
                    "title": "Notes Uid",
                    "type": "string",
                    "uid_resource_type": "resource_note"
                },
                "state": {
                    "class_name": "YardiVoyagerTransactionState",
                    "enum": [
                        "awaiting_processing",
                        "converted_to_deposit_intent",
                        "abandoned"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "version": {
                    "maxLength": 10,
                    "minLength": 1,
                    "title": "Version",
                    "type": "string"
                },
                "voyager_charge_code": {
                    "maxLength": 8,
                    "title": "Voyager Charge Code",
                    "type": "string"
                },
                "voyager_charge_uid": {
                    "reference_type": "uuid",
                    "title": "Voyager Charge Uid",
                    "type": "string",
                    "uid_resource_type": "yardi_voyager_charge"
                },
                "voyager_person_code": {
                    "title": "Voyager Person Code",
                    "type": "string"
                },
                "voyager_property_uid": {
                    "reference_type": "uuid",
                    "title": "Voyager Property Uid",
                    "type": "string",
                    "uid_resource_type": "yardi_voyager_property"
                },
                "voyager_property_unit_uid": {
                    "reference_type": "uuid",
                    "title": "Voyager Property Unit Uid",
                    "type": "string",
                    "uid_resource_type": "yardi_voyager_property_unit"
                },
                "voyager_resident_uid": {
                    "reference_type": "uuid",
                    "title": "Voyager Resident Uid",
                    "type": "string",
                    "uid_resource_type": "yardi_voyager_resident"
                },
                "voyager_xml_uid": {
                    "reference_type": "uuid",
                    "title": "Voyager Xml Uid",
                    "type": "string",
                    "uid_resource_type": "yardi_voyager_xml"
                }
            },
            "required": [
                "admin_error_info",
                "charge_amount_in_cents",
                "charge_code_string",
                "charge_code_uid",
                "charge_comments",
                "deposify_pmc_account_uid",
                "intent_type",
                "intent_uid",
                "state",
                "version",
                "voyager_charge_code",
                "voyager_charge_uid",
                "voyager_person_code",
                "voyager_property_uid",
                "voyager_property_unit_uid",
                "voyager_resident_uid",
                "voyager_xml_uid"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _YARDI_VOYAGER_CHARGE_CODE_JSON_SCHEMA = {
    "$ref": "#/definitions/YardiVoyagerChargeCodeSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "YardiVoyagerChargeCodeSchema": {
            "additionalProperties": false,
            "properties": {
                "charge_code_string": {
                    "maxLength": 8,
                    "title": "Charge Code String",
                    "type": "string"
                },
                "charge_code_uid": {
                    "reference_type": "uuid",
                    "title": "Charge Code Uid",
                    "type": "string",
                    "uid_resource_type": "yardi_voyager_charge_code"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "deposify_tags": {
                    "items": {
                        "format": "integer",
                        "title": "deposify_tags",
                        "type": "number"
                    },
                    "title": "Deposify Tags",
                    "type": "array"
                },
                "intent": {
                    "class_name": "YardiVoyagerChargeCodeIntent",
                    "enum": [
                        "deposify_security_deposit",
                        "deposify_pet_deposit",
                        "deposify_utility_deposit",
                        "deposify_close_deposit",
                        "deposify_withhold_deposit_funds"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "notes_uid": {
                    "reference_type": "uuid",
                    "title": "Notes Uid",
                    "type": "string",
                    "uid_resource_type": "resource_note"
                },
                "owner": {
                    "class_name": "YardiVoyagerContentOwner",
                    "enum": [
                        "deposify",
                        "assurant"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "public_description": {
                    "title": "Public Description",
                    "type": "string"
                },
                "state": {
                    "class_name": "YardiVoyagerChargeCodeState",
                    "enum": [
                        "enabled",
                        "disabled"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "version": {
                    "maxLength": 10,
                    "minLength": 1,
                    "title": "Version",
                    "type": "string"
                }
            },
            "required": [
                "charge_code_string",
                "charge_code_uid",
                "intent",
                "owner",
                "public_description",
                "state",
                "version"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _YARDI_VOYAGER_DEPOSIT_CLOSE_INTENT_JSON_SCHEMA = {
    "$ref": "#/definitions/YardiVoyagerDepositCloseIntentSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "YardiVoyagerDepositCloseIntentSchema": {
            "additionalProperties": false,
            "properties": {
                "account_uids_with_read_permission": {
                    "items": {
                        "title": "account_uids_with_read_permission",
                        "type": "string"
                    },
                    "reference_type": "uuid",
                    "title": "Account Uids With Read Permission",
                    "type": "array",
                    "uid_resource_type": "user_account"
                },
                "action_intent_after_timestamp": {
                    "format": "date-time",
                    "title": "Action Intent After Timestamp",
                    "type": "string"
                },
                "admin_error_message": {
                    "maxLength": 1024,
                    "title": "Admin Error Message",
                    "type": "string"
                },
                "charge_code": {
                    "maxLength": 8,
                    "title": "Charge Code",
                    "type": "string"
                },
                "close_action": {
                    "class_name": "YardiVoyagerDepositCloseIntentActionType",
                    "enum": [
                        "cancel_deposit",
                        "landlord_close_deposit",
                        "close_requested",
                        "already_closed",
                        "disputed",
                        "already_cancelled"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "close_intent_uid": {
                    "reference_type": "uuid",
                    "title": "Close Intent Uid",
                    "type": "string",
                    "uid_resource_type": "yardi_voyager_deposit_close_intent"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "deposify_pmc_account_uid": {
                    "reference_type": "uuid",
                    "title": "Deposify Pmc Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "deposify_tags": {
                    "items": {
                        "format": "integer",
                        "title": "deposify_tags",
                        "type": "number"
                    },
                    "title": "Deposify Tags",
                    "type": "array"
                },
                "intent_cancel_reason": {
                    "class_name": "YardiVoyagerIntentCancelReason",
                    "enum": [
                        "not_cancelled",
                        "pmc_cancelled",
                        "admin_cancelled",
                        "status_changed_to_past",
                        "converted_to_flex"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "intent_creation_reason": {
                    "class_name": "YardiVoyagerIntentCreationReason",
                    "enum": [
                        "new_resident",
                        "status_change",
                        "move_out_date_added",
                        "roommate_promotion"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "notes_uid": {
                    "reference_type": "uuid",
                    "title": "Notes Uid",
                    "type": "string",
                    "uid_resource_type": "resource_note"
                },
                "organization_uids_with_read_permission": {
                    "items": {
                        "title": "organization_uids_with_read_permission",
                        "type": "string"
                    },
                    "reference_type": "uuid",
                    "title": "Organization Uids With Read Permission",
                    "type": "array",
                    "uid_resource_type": "user_account"
                },
                "remind_after_timestamp": {
                    "format": "date-time",
                    "title": "Remind After Timestamp",
                    "type": "string"
                },
                "source": {
                    "class_name": "YardiVoyagerIntentSource",
                    "enum": [
                        "status_change",
                        "transaction",
                        "admin"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "state": {
                    "class_name": "YardiVoyagerDepositCloseIntentState",
                    "enum": [
                        "awaiting_pmc_action",
                        "actioned",
                        "cancelled",
                        "error",
                        "awaiting_reminder_deadline",
                        "awaiting_action_after_deadline"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "version": {
                    "maxLength": 10,
                    "minLength": 1,
                    "title": "Version",
                    "type": "string"
                },
                "voyager_property_unit_id": {
                    "maxLength": 256,
                    "title": "Voyager Property Unit Id",
                    "type": "string"
                },
                "yardi_voyager_property_uid": {
                    "reference_type": "uuid",
                    "title": "Yardi Voyager Property Uid",
                    "type": "string",
                    "uid_resource_type": "yardi_voyager_property_unit"
                },
                "yardi_voyager_property_unit_uid": {
                    "reference_type": "uuid",
                    "title": "Yardi Voyager Property Unit Uid",
                    "type": "string",
                    "uid_resource_type": "yardi_voyager_property_unit"
                },
                "yardi_voyager_resident_uid": {
                    "reference_type": "uuid",
                    "title": "Yardi Voyager Resident Uid",
                    "type": "string",
                    "uid_resource_type": "yardi_voyager_resident"
                },
                "yardi_voyager_transaction_uid": {
                    "reference_type": "uuid",
                    "title": "Yardi Voyager Transaction Uid",
                    "type": "string",
                    "uid_resource_type": "yardi_voyager_transaction"
                }
            },
            "required": [
                "action_intent_after_timestamp",
                "admin_error_message",
                "charge_code",
                "close_action",
                "close_intent_uid",
                "deposify_pmc_account_uid",
                "intent_cancel_reason",
                "intent_creation_reason",
                "remind_after_timestamp",
                "source",
                "state",
                "version",
                "voyager_property_unit_id",
                "yardi_voyager_property_uid",
                "yardi_voyager_property_unit_uid",
                "yardi_voyager_resident_uid",
                "yardi_voyager_transaction_uid"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _YARDI_VOYAGER_DEPOSIT_CREATE_INTENT_JSON_SCHEMA = {
    "$ref": "#/definitions/YardiVoyagerDepositCreateIntentSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "YardiVoyagerDepositCreateIntentSchema": {
            "additionalProperties": false,
            "properties": {
                "account_uids_with_read_permission": {
                    "items": {
                        "title": "account_uids_with_read_permission",
                        "type": "string"
                    },
                    "reference_type": "uuid",
                    "title": "Account Uids With Read Permission",
                    "type": "array",
                    "uid_resource_type": "user_account"
                },
                "action_intent_after_timestamp": {
                    "format": "date-time",
                    "title": "Action Intent After Timestamp",
                    "type": "string"
                },
                "admin_error_message": {
                    "maxLength": 1024,
                    "title": "Admin Error Message",
                    "type": "string"
                },
                "amount_in_cents": {
                    "cents_value": true,
                    "format": "integer",
                    "maximum": 9223372036854775807,
                    "minimum": 0,
                    "title": "Amount",
                    "type": "number",
                    "ui:placeholder": "$0",
                    "ui:widget": "DollarInputField"
                },
                "charge_code": {
                    "maxLength": 8,
                    "title": "Charge Code",
                    "type": "string"
                },
                "create_intent_type": {
                    "class_name": "YardiVoyagerDepositCreateIntentType",
                    "enum": [
                        "new_deposit",
                        "roommate_promotion"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "create_intent_uid": {
                    "reference_type": "uuid",
                    "title": "Create Intent Uid",
                    "type": "string",
                    "uid_resource_type": "yardi_voyager_deposit_create_intent"
                },
                "created_deposit_uid": {
                    "reference_type": "uuid",
                    "title": "Created Deposit Uid",
                    "type": "string",
                    "uid_resource_type": "deposit"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "deposify_pmc_account_uid": {
                    "reference_type": "uuid",
                    "title": "Deposify Pmc Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "deposify_tags": {
                    "items": {
                        "format": "integer",
                        "title": "deposify_tags",
                        "type": "number"
                    },
                    "title": "Deposify Tags",
                    "type": "array"
                },
                "deposit_invite_sent": {
                    "title": "Deposit Invite Sent",
                    "type": "boolean"
                },
                "end_date": {
                    "format": "date-time",
                    "title": "End Date",
                    "type": "string"
                },
                "geo_state": {
                    "maxLength": 2,
                    "title": "Geo State",
                    "type": "string"
                },
                "intent_cancel_reason": {
                    "class_name": "YardiVoyagerIntentCancelReason",
                    "enum": [
                        "not_cancelled",
                        "pmc_cancelled",
                        "admin_cancelled",
                        "status_changed_to_past",
                        "converted_to_flex"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "intent_creation_reason": {
                    "class_name": "YardiVoyagerIntentCreationReason",
                    "enum": [
                        "new_resident",
                        "status_change",
                        "move_out_date_added",
                        "roommate_promotion"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "notes_uid": {
                    "reference_type": "uuid",
                    "title": "Notes Uid",
                    "type": "string",
                    "uid_resource_type": "resource_note"
                },
                "organization_uids_with_read_permission": {
                    "items": {
                        "title": "organization_uids_with_read_permission",
                        "type": "string"
                    },
                    "reference_type": "uuid",
                    "title": "Organization Uids With Read Permission",
                    "type": "array",
                    "uid_resource_type": "user_account"
                },
                "remind_after_timestamp": {
                    "format": "date-time",
                    "title": "Remind After Timestamp",
                    "type": "string"
                },
                "source": {
                    "class_name": "YardiVoyagerIntentSource",
                    "enum": [
                        "status_change",
                        "transaction",
                        "admin"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "start_date": {
                    "format": "date-time",
                    "title": "Start Date",
                    "type": "string"
                },
                "state": {
                    "class_name": "YardiVoyagerDepositCreateIntentState",
                    "enum": [
                        "awaiting_pmc_action",
                        "awaiting_creation",
                        "created",
                        "cancelled",
                        "error",
                        "awaiting_reminder_deadline",
                        "awaiting_action_after_deadline"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "version": {
                    "maxLength": 10,
                    "minLength": 1,
                    "title": "Version",
                    "type": "string"
                },
                "voyager_property_unit_id": {
                    "maxLength": 256,
                    "title": "Voyager Property Unit Id",
                    "type": "string"
                },
                "yardi_voyager_outgoing_resident_uid": {
                    "reference_type": "uuid",
                    "title": "Yardi Voyager Outgoing Resident Uid",
                    "type": "string",
                    "uid_resource_type": "yardi_voyager_resident"
                },
                "yardi_voyager_property_uid": {
                    "reference_type": "uuid",
                    "title": "Yardi Voyager Property Uid",
                    "type": "string",
                    "uid_resource_type": "yardi_voyager_property_unit"
                },
                "yardi_voyager_property_unit_uid": {
                    "reference_type": "uuid",
                    "title": "Yardi Voyager Property Unit Uid",
                    "type": "string",
                    "uid_resource_type": "yardi_voyager_property_unit"
                },
                "yardi_voyager_resident_uid": {
                    "reference_type": "uuid",
                    "title": "Yardi Voyager Resident Uid",
                    "type": "string",
                    "uid_resource_type": "yardi_voyager_resident"
                },
                "yardi_voyager_transaction_uid": {
                    "reference_type": "uuid",
                    "title": "Yardi Voyager Transaction Uid",
                    "type": "string",
                    "uid_resource_type": "yardi_voyager_transaction"
                }
            },
            "required": [
                "action_intent_after_timestamp",
                "admin_error_message",
                "amount_in_cents",
                "charge_code",
                "create_intent_type",
                "create_intent_uid",
                "created_deposit_uid",
                "deposify_pmc_account_uid",
                "deposit_invite_sent",
                "end_date",
                "geo_state",
                "intent_cancel_reason",
                "intent_creation_reason",
                "remind_after_timestamp",
                "source",
                "start_date",
                "state",
                "version",
                "voyager_property_unit_id",
                "yardi_voyager_outgoing_resident_uid",
                "yardi_voyager_property_uid",
                "yardi_voyager_property_unit_uid",
                "yardi_voyager_resident_uid",
                "yardi_voyager_transaction_uid"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _YARDI_VOYAGER_DEPOSIT_WITHHOLD_INTENT_JSON_SCHEMA = {
    "$ref": "#/definitions/YardiVoyagerDepositWithholdIntentSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "YardiVoyagerDepositWithholdIntentSchema": {
            "additionalProperties": false,
            "properties": {
                "admin_error_message": {
                    "title": "Admin Error Message",
                    "type": "string"
                },
                "charge_code": {
                    "maxLength": 8,
                    "title": "Charge Code",
                    "type": "string"
                },
                "create_deposit_timestamp": {
                    "format": "date-time",
                    "title": "Create Deposit Timestamp",
                    "type": "string"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "deposify_tags": {
                    "items": {
                        "format": "integer",
                        "title": "deposify_tags",
                        "type": "number"
                    },
                    "title": "Deposify Tags",
                    "type": "array"
                },
                "landlord_account_uid": {
                    "reference_type": "uuid",
                    "title": "Landlord Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "notes_uid": {
                    "reference_type": "uuid",
                    "title": "Notes Uid",
                    "type": "string",
                    "uid_resource_type": "resource_note"
                },
                "state": {
                    "class_name": "YardiVoyagerDepositWithholdIntentState",
                    "enum": [
                        "awaiting_withhold",
                        "withhold_complete",
                        "error"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "version": {
                    "maxLength": 10,
                    "minLength": 1,
                    "title": "Version",
                    "type": "string"
                },
                "withhold_intent_uid": {
                    "reference_type": "uuid",
                    "title": "Withhold Intent Uid",
                    "type": "string",
                    "uid_resource_type": "yardi_voyager_deposit_withhold_intent"
                },
                "yardi_voyager_property_unit_uid": {
                    "reference_type": "uuid",
                    "title": "Yardi Voyager Property Unit Uid",
                    "type": "string",
                    "uid_resource_type": "yardi_voyager_property_unit"
                },
                "yardi_voyager_transaction_uid": {
                    "reference_type": "uuid",
                    "title": "Yardi Voyager Transaction Uid",
                    "type": "string",
                    "uid_resource_type": "yardi_voyager_transaction"
                },
                "yardi_voyager_xml_uid": {
                    "reference_type": "uuid",
                    "title": "Yardi Voyager Xml Uid",
                    "type": "string",
                    "uid_resource_type": "yardi_voyager_xml"
                }
            },
            "required": [
                "admin_error_message",
                "charge_code",
                "create_deposit_timestamp",
                "landlord_account_uid",
                "state",
                "version",
                "withhold_intent_uid",
                "yardi_voyager_property_unit_uid",
                "yardi_voyager_transaction_uid",
                "yardi_voyager_xml_uid"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _YARDI_VOYAGER_EVENT_JSON_SCHEMA = {
    "$ref": "#/definitions/YardiVoyagerEventSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "YardiVoyagerEventSchema": {
            "additionalProperties": false,
            "properties": {
                "assurant_acknowledged_timestamp": {
                    "format": "date-time",
                    "title": "Assurant Acknowledged Timestamp",
                    "type": "string"
                },
                "assurant_of_interest_flag": {
                    "title": "Assurant Of Interest Flag",
                    "type": "boolean"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "deposify_pmc_account_uid": {
                    "reference_type": "uuid",
                    "title": "Deposify Pmc Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "deposify_tags": {
                    "items": {
                        "format": "integer",
                        "title": "deposify_tags",
                        "type": "number"
                    },
                    "title": "Deposify Tags",
                    "type": "array"
                },
                "event_payload": {
                    "additionalProperties": {},
                    "title": "Event Payload",
                    "type": "object"
                },
                "event_type": {
                    "class_name": "YardiVoyagerEventType",
                    "enum": [
                        "voyager_pmc_created",
                        "property_created",
                        "property_configurations_check_completed",
                        "property_restored_to_active",
                        "property_initial_ils_guest_scan_completed",
                        "property_unit_information_check_complete",
                        "new_property_unit_updated_existing_property_info",
                        "ils_guest_tenant_code_ignored",
                        "get_tenant_status_of_a_property_check_complete",
                        "resident_dropped_from_get_status_list",
                        "resident_status_changed",
                        "resident_tenant_code_changed",
                        "resident_created_via_resident_data",
                        "resident_created_via_ils_guest",
                        "tenant_account_created_for_resident",
                        "resident_processing_skipped",
                        "create_deposit_intent_created",
                        "close_deposit_intent_created",
                        "create_deposit_intent_cancelled",
                        "create_deposit_intent_confirmed",
                        "close_deposit_intent_cancelled",
                        "close_deposit_intent_confirmed",
                        "create_deposit_intent_set_remind_me_later",
                        "close_deposit_intent_set_remind_me_later",
                        "deposit_intent_invite_sent",
                        "assurant_flex_deposit_intent_created",
                        "flex_deposit_created_from_deposit_create_intent",
                        "flex_deposit_intent_set_remind_me_later",
                        "flex_deposit_intent_cancelled",
                        "flex_deposit_intent_confirmed"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "event_uid": {
                    "reference_type": "uuid",
                    "title": "Event Uid",
                    "type": "string",
                    "uid_resource_type": "yardi_voyager_event"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "notes_uid": {
                    "reference_type": "uuid",
                    "title": "Notes Uid",
                    "type": "string",
                    "uid_resource_type": "resource_note"
                },
                "resource_uid": {
                    "reference_type": "uuid",
                    "title": "Resource Uid",
                    "type": "string"
                },
                "version": {
                    "maxLength": 10,
                    "minLength": 1,
                    "title": "Version",
                    "type": "string"
                },
                "voyager_property_uid": {
                    "reference_type": "uuid",
                    "title": "Voyager Property Uid",
                    "type": "string",
                    "uid_resource_type": "yardi_voyager_property"
                },
                "voyager_property_unit_uid": {
                    "reference_type": "uuid",
                    "title": "Voyager Property Unit Uid",
                    "type": "string",
                    "uid_resource_type": "yardi_voyager_property_unit"
                },
                "voyager_resource_type": {
                    "class_name": "YardiVoyagerResourceType",
                    "enum": [
                        "yardi_screening_works_pro_xml",
                        "yardi_voyager_xml",
                        "yardi_voyager_transaction",
                        "yardi_voyager_resident",
                        "yardi_voyager_resident_custom_column",
                        "yardi_voyager_property_unit",
                        "yardi_voyager_property",
                        "yardi_voyager_pmc_service_interface_version",
                        "yardi_voyager_pmc",
                        "yardi_voyager_pmc_credentials",
                        "yardi_voyager_pet",
                        "yardi_voyager_ils_guest_card_event",
                        "yardi_voyager_charge",
                        "yardi_voyager_charge_code",
                        "yardi_voyager_deposit_create_intent",
                        "yardi_voyager_deposit_close_intent",
                        "yardi_voyager_deposit_withhold_intent",
                        "yardi_voyager_event",
                        "yardi_voyager_flex_deposit_intent",
                        "yardi_voyager_phone",
                        "yardi_voyager_other_occupant",
                        "yardi_voyager_pmc_custom_column_settings",
                        "yardi_voyager_pmc_stats",
                        "yardi_voyager_pmc_stats_collector",
                        "yardi_voyager_active_scan_log_entry",
                        "yardi_voyager_system_settings"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                }
            },
            "required": [
                "assurant_acknowledged_timestamp",
                "assurant_of_interest_flag",
                "deposify_pmc_account_uid",
                "event_payload",
                "event_type",
                "event_uid",
                "resource_uid",
                "version",
                "voyager_property_uid",
                "voyager_property_unit_uid",
                "voyager_resource_type"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _YARDI_VOYAGER_FLEX_DEPOSIT_INTENT_JSON_SCHEMA = {
    "$ref": "#/definitions/YardiVoyagerFlexDepositIntentSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "YardiVoyagerFlexDepositIntentSchema": {
            "additionalProperties": false,
            "properties": {
                "account_uids_with_read_permission": {
                    "items": {
                        "title": "account_uids_with_read_permission",
                        "type": "string"
                    },
                    "reference_type": "uuid",
                    "title": "Account Uids With Read Permission",
                    "type": "array",
                    "uid_resource_type": "user_account"
                },
                "action_intent_after_timestamp": {
                    "format": "date-time",
                    "title": "Action Intent After Timestamp",
                    "type": "string"
                },
                "admin_error_message": {
                    "maxLength": 1024,
                    "title": "Admin Error Message",
                    "type": "string"
                },
                "bond_amount_in_cents": {
                    "cents_value": true,
                    "format": "integer",
                    "maximum": 9223372036854775807,
                    "minimum": 0,
                    "title": "Bond Amount In Cents",
                    "type": "number"
                },
                "bond_id": {
                    "format": "integer",
                    "title": "Bond Id",
                    "type": "number"
                },
                "bond_status": {
                    "format": "integer",
                    "title": "Bond Status",
                    "type": "number"
                },
                "charge_code": {
                    "maxLength": 8,
                    "title": "Charge Code",
                    "type": "string"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "deposify_pmc_account_uid": {
                    "reference_type": "uuid",
                    "title": "Deposify Pmc Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "deposify_tags": {
                    "items": {
                        "format": "integer",
                        "title": "deposify_tags",
                        "type": "number"
                    },
                    "title": "Deposify Tags",
                    "type": "array"
                },
                "deposit_amount_in_cents": {
                    "cents_value": true,
                    "format": "integer",
                    "maximum": 9223372036854775807,
                    "minimum": 0,
                    "title": "Deposit Amount In Cents",
                    "type": "number"
                },
                "end_date": {
                    "format": "date-time",
                    "title": "End Date",
                    "type": "string"
                },
                "flex_intent_uid": {
                    "reference_type": "uuid",
                    "title": "Flex Intent Uid",
                    "type": "string",
                    "uid_resource_type": "yardi_voyager_flex_deposit_intent"
                },
                "geo_state": {
                    "maxLength": 2,
                    "title": "Geo State",
                    "type": "string"
                },
                "intent_cancel_reason": {
                    "class_name": "YardiVoyagerIntentCancelReason",
                    "enum": [
                        "not_cancelled",
                        "pmc_cancelled",
                        "admin_cancelled",
                        "status_changed_to_past",
                        "converted_to_flex"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "intent_creation_reason": {
                    "class_name": "YardiVoyagerIntentCreationReason",
                    "enum": [
                        "new_resident",
                        "status_change",
                        "move_out_date_added",
                        "roommate_promotion"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "notes_uid": {
                    "reference_type": "uuid",
                    "title": "Notes Uid",
                    "type": "string",
                    "uid_resource_type": "resource_note"
                },
                "organization_uids_with_read_permission": {
                    "items": {
                        "title": "organization_uids_with_read_permission",
                        "type": "string"
                    },
                    "reference_type": "uuid",
                    "title": "Organization Uids With Read Permission",
                    "type": "array",
                    "uid_resource_type": "user_account"
                },
                "parent_deposit_create_intent_uid": {
                    "reference_type": "uuid",
                    "title": "Parent Deposit Create Intent Uid",
                    "type": "string",
                    "uid_resource_type": "yardi_voyager_deposit_create_intent"
                },
                "remind_after_timestamp": {
                    "format": "date-time",
                    "title": "Remind After Timestamp",
                    "type": "string"
                },
                "source": {
                    "class_name": "YardiVoyagerIntentSource",
                    "enum": [
                        "status_change",
                        "transaction",
                        "admin"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "start_date": {
                    "format": "date-time",
                    "title": "Start Date",
                    "type": "string"
                },
                "state": {
                    "class_name": "YardiVoyagerDepositCreateIntentState",
                    "enum": [
                        "awaiting_pmc_action",
                        "awaiting_creation",
                        "created",
                        "cancelled",
                        "error",
                        "awaiting_reminder_deadline",
                        "awaiting_action_after_deadline"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "version": {
                    "maxLength": 10,
                    "minLength": 1,
                    "title": "Version",
                    "type": "string"
                },
                "yardi_voyager_property_uid": {
                    "reference_type": "uuid",
                    "title": "Yardi Voyager Property Uid",
                    "type": "string",
                    "uid_resource_type": "yardi_voyager_property"
                },
                "yardi_voyager_property_unit_uid": {
                    "reference_type": "uuid",
                    "title": "Yardi Voyager Property Unit Uid",
                    "type": "string",
                    "uid_resource_type": "yardi_voyager_property_unit"
                },
                "yardi_voyager_resident_uid": {
                    "reference_type": "uuid",
                    "title": "Yardi Voyager Resident Uid",
                    "type": "string",
                    "uid_resource_type": "yardi_voyager_resident"
                },
                "yardi_voyager_transaction_uid": {
                    "reference_type": "uuid",
                    "title": "Yardi Voyager Transaction Uid",
                    "type": "string",
                    "uid_resource_type": "yardi_voyager_transaction"
                }
            },
            "required": [
                "action_intent_after_timestamp",
                "admin_error_message",
                "bond_amount_in_cents",
                "bond_id",
                "bond_status",
                "charge_code",
                "deposify_pmc_account_uid",
                "deposit_amount_in_cents",
                "end_date",
                "flex_intent_uid",
                "geo_state",
                "intent_cancel_reason",
                "intent_creation_reason",
                "parent_deposit_create_intent_uid",
                "remind_after_timestamp",
                "source",
                "start_date",
                "state",
                "version",
                "yardi_voyager_property_uid",
                "yardi_voyager_property_unit_uid",
                "yardi_voyager_resident_uid",
                "yardi_voyager_transaction_uid"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _YARDI_VOYAGER_ILS_GUEST_CARD_EVENT_JSON_SCHEMA = {
    "$ref": "#/definitions/YardiVoyagerILSGuestCardEventSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "YardiVoyagerILSGuestCardEventSchema": {
            "additionalProperties": false,
            "properties": {
                "content_owner": {
                    "class_name": "YardiVoyagerContentOwner",
                    "enum": [
                        "deposify",
                        "assurant"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "deposify_tags": {
                    "items": {
                        "format": "integer",
                        "title": "deposify_tags",
                        "type": "number"
                    },
                    "title": "Deposify Tags",
                    "type": "array"
                },
                "event_id": {
                    "format": "integer",
                    "title": "Event Id",
                    "type": "number"
                },
                "event_text": {
                    "title": "Event Text",
                    "type": "string"
                },
                "guest_card_event_uid": {
                    "reference_type": "uuid",
                    "title": "Guest Card Event Uid",
                    "type": "string",
                    "uid_resource_type": "yardi_voyager_ils_guest_card_event"
                },
                "last_update_failure_timestamp": {
                    "format": "date-time",
                    "title": "Last Update Failure Timestamp",
                    "type": "string"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "notes_uid": {
                    "reference_type": "uuid",
                    "title": "Notes Uid",
                    "type": "string",
                    "uid_resource_type": "resource_note"
                },
                "state": {
                    "class_name": "YardiVoyagerILSEventState",
                    "enum": [
                        "okay",
                        "awaiting_push_to_voyager",
                        "unsent_due_to_pmc_or_resident",
                        "unsent_due_to_too_many_failures"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "update_failure_count": {
                    "format": "integer",
                    "title": "Update Failure Count",
                    "type": "number"
                },
                "version": {
                    "maxLength": 10,
                    "minLength": 1,
                    "title": "Version",
                    "type": "string"
                },
                "voyager_resident_uid": {
                    "reference_type": "uuid",
                    "title": "Voyager Resident Uid",
                    "type": "string",
                    "uid_resource_type": "yardi_voyager_resident"
                }
            },
            "required": [
                "content_owner",
                "event_id",
                "event_text",
                "guest_card_event_uid",
                "last_update_failure_timestamp",
                "state",
                "update_failure_count",
                "version",
                "voyager_resident_uid"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _YARDI_VOYAGER_OTHER_OCCUPANT_JSON_SCHEMA = {
    "$ref": "#/definitions/YardiVoyagerOtherOccupantSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "YardiVoyagerOtherOccupantSchema": {
            "additionalProperties": false,
            "properties": {
                "account_uids_with_read_permission": {
                    "items": {
                        "title": "account_uids_with_read_permission",
                        "type": "string"
                    },
                    "reference_type": "uuid",
                    "title": "Account Uids With Read Permission",
                    "type": "array",
                    "uid_resource_type": "user_account"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "deposify_pmc_account_uid": {
                    "title": "Deposify Pmc Account Uid",
                    "type": "string"
                },
                "deposify_tags": {
                    "items": {
                        "format": "integer",
                        "title": "deposify_tags",
                        "type": "number"
                    },
                    "title": "Deposify Tags",
                    "type": "array"
                },
                "email_address": {
                    "title": "Email Address",
                    "type": "string"
                },
                "email_hash": {
                    "title": "Email Hash",
                    "type": "string"
                },
                "first_name": {
                    "title": "First Name",
                    "type": "string"
                },
                "last_name": {
                    "title": "Last Name",
                    "type": "string"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "notes_uid": {
                    "reference_type": "uuid",
                    "title": "Notes Uid",
                    "type": "string",
                    "uid_resource_type": "resource_note"
                },
                "organization_uids_with_read_permission": {
                    "items": {
                        "title": "organization_uids_with_read_permission",
                        "type": "string"
                    },
                    "reference_type": "uuid",
                    "title": "Organization Uids With Read Permission",
                    "type": "array",
                    "uid_resource_type": "user_account"
                },
                "other_occupant_uid": {
                    "reference_type": "uuid",
                    "title": "Other Occupant Uid",
                    "type": "string",
                    "uid_resource_type": "yardi_voyager_other_occupant"
                },
                "parent_voyager_resident_uid": {
                    "reference_type": "uuid",
                    "title": "Parent Voyager Resident Uid",
                    "type": "string",
                    "uid_resource_type": "yardi_voyager_resident"
                },
                "version": {
                    "maxLength": 10,
                    "minLength": 1,
                    "title": "Version",
                    "type": "string"
                },
                "voyager_property_uid": {
                    "reference_type": "uuid",
                    "title": "Voyager Property Uid",
                    "type": "string",
                    "uid_resource_type": "yardi_voyager_property"
                },
                "voyager_property_unit_uid": {
                    "reference_type": "uuid",
                    "title": "Voyager Property Unit Uid",
                    "type": "string",
                    "uid_resource_type": "yardi_voyager_property_unit"
                },
                "voyager_prospect_code": {
                    "title": "Voyager Prospect Code",
                    "type": "string"
                },
                "voyager_roommate_code": {
                    "title": "Voyager Roommate Code",
                    "type": "string"
                },
                "voyager_roommate_code_type": {
                    "title": "Voyager Roommate Code Type",
                    "type": "string"
                },
                "voyager_tenant_code": {
                    "title": "Voyager Tenant Code",
                    "type": "string"
                }
            },
            "required": [
                "deposify_pmc_account_uid",
                "email_address",
                "email_hash",
                "first_name",
                "last_name",
                "other_occupant_uid",
                "parent_voyager_resident_uid",
                "version",
                "voyager_property_uid",
                "voyager_property_unit_uid",
                "voyager_prospect_code",
                "voyager_roommate_code",
                "voyager_roommate_code_type",
                "voyager_tenant_code"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _YARDI_VOYAGER_PET_JSON_SCHEMA = {
    "$ref": "#/definitions/YardiVoyagerPetSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "YardiVoyagerPetSchema": {
            "additionalProperties": false,
            "properties": {
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "deposify_pmc_account_uid": {
                    "reference_type": "uuid",
                    "title": "Deposify Pmc Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "deposify_tags": {
                    "items": {
                        "format": "integer",
                        "title": "deposify_tags",
                        "type": "number"
                    },
                    "title": "Deposify Tags",
                    "type": "array"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "neutered": {
                    "title": "Neutered",
                    "type": "boolean"
                },
                "notes_uid": {
                    "reference_type": "uuid",
                    "title": "Notes Uid",
                    "type": "string",
                    "uid_resource_type": "resource_note"
                },
                "pet_color": {
                    "title": "Pet Color",
                    "type": "string"
                },
                "pet_name": {
                    "title": "Pet Name",
                    "type": "string"
                },
                "pet_type": {
                    "title": "Pet Type",
                    "type": "string"
                },
                "pet_uid": {
                    "reference_type": "uuid",
                    "title": "Pet Uid",
                    "type": "string",
                    "uid_resource_type": "yardi_voyager_pet"
                },
                "service_animal": {
                    "title": "Service Animal",
                    "type": "boolean"
                },
                "version": {
                    "maxLength": 10,
                    "minLength": 1,
                    "title": "Version",
                    "type": "string"
                },
                "voyager_pet_code": {
                    "title": "Voyager Pet Code",
                    "type": "string"
                },
                "voyager_resident_uid": {
                    "reference_type": "uuid",
                    "title": "Voyager Resident Uid",
                    "type": "string",
                    "uid_resource_type": "yardi_voyager_resident"
                }
            },
            "required": [
                "deposify_pmc_account_uid",
                "neutered",
                "pet_color",
                "pet_name",
                "pet_type",
                "pet_uid",
                "service_animal",
                "version",
                "voyager_pet_code",
                "voyager_resident_uid"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _YARDI_VOYAGER_PHONE_JSON_SCHEMA = {
    "$ref": "#/definitions/YardiVoyagerPhoneSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "YardiVoyagerPhoneSchema": {
            "additionalProperties": false,
            "properties": {
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "deposify_pmc_account_uid": {
                    "reference_type": "uuid",
                    "title": "Deposify Pmc Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "deposify_tags": {
                    "items": {
                        "format": "integer",
                        "title": "deposify_tags",
                        "type": "number"
                    },
                    "title": "Deposify Tags",
                    "type": "array"
                },
                "details_hash": {
                    "title": "Details Hash",
                    "type": "string"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "notes_uid": {
                    "reference_type": "uuid",
                    "title": "Notes Uid",
                    "type": "string",
                    "uid_resource_type": "resource_note"
                },
                "phone_description": {
                    "title": "Phone Description",
                    "type": "string"
                },
                "phone_number": {
                    "title": "Phone Number",
                    "type": "string"
                },
                "phone_type": {
                    "title": "Phone Type",
                    "type": "string"
                },
                "phone_uid": {
                    "reference_type": "uuid",
                    "title": "Phone Uid",
                    "type": "string",
                    "uid_resource_type": "yardi_voyager_phone"
                },
                "version": {
                    "maxLength": 10,
                    "minLength": 1,
                    "title": "Version",
                    "type": "string"
                },
                "voyager_resident_uid": {
                    "reference_type": "uuid",
                    "title": "Voyager Resident Uid",
                    "type": "string",
                    "uid_resource_type": "yardi_voyager_resident"
                }
            },
            "required": [
                "deposify_pmc_account_uid",
                "details_hash",
                "phone_description",
                "phone_number",
                "phone_type",
                "phone_uid",
                "version",
                "voyager_resident_uid"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _YARDI_VOYAGER_PMC_JSON_SCHEMA = {
    "$ref": "#/definitions/YardiVoyagerPMCSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "YardiVoyagerPMCSchema": {
            "additionalProperties": false,
            "properties": {
                "allow_get_tenant_status_checks": {
                    "title": "Allow Get Tenant Status Checks",
                    "type": "boolean"
                },
                "allow_ils_guest_card_activity_checks": {
                    "title": "Allow Ils Guest Card Activity Checks",
                    "type": "boolean"
                },
                "allow_permission_checks": {
                    "title": "Allow Permission Checks",
                    "type": "boolean"
                },
                "allow_property_configuration_checks": {
                    "title": "Allow Property Configuration Checks",
                    "type": "boolean"
                },
                "allow_unit_information_checks": {
                    "title": "Allow Unit Information Checks",
                    "type": "boolean"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "deposify_pmc_account_uid": {
                    "reference_type": "uuid",
                    "title": "Deposify Pmc Account Uid",
                    "type": "string",
                    "uid_resource_type": "yardi_voyager_pmc"
                },
                "deposify_tags": {
                    "items": {
                        "format": "integer",
                        "title": "deposify_tags",
                        "type": "number"
                    },
                    "title": "Deposify Tags",
                    "type": "array"
                },
                "error_codes": {
                    "items": {
                        "format": "integer",
                        "title": "error_codes",
                        "type": "number"
                    },
                    "title": "Error Codes",
                    "type": "array"
                },
                "has_custom_columns": {
                    "title": "Has Custom Columns",
                    "type": "boolean"
                },
                "last_permission_check_timestamp": {
                    "format": "date-time",
                    "title": "Last Permission Check Timestamp",
                    "type": "string"
                },
                "last_property_config_scan_timestamp": {
                    "format": "date-time",
                    "title": "Last Property Config Scan Timestamp",
                    "type": "string"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "needed_common_data_read_permission": {
                    "items": {
                        "format": "integer",
                        "title": "needed_common_data_read_permission",
                        "type": "number"
                    },
                    "title": "Needed Common Data Read Permission",
                    "type": "array"
                },
                "needed_common_data_write_permission": {
                    "items": {
                        "format": "integer",
                        "title": "needed_common_data_write_permission",
                        "type": "number"
                    },
                    "title": "Needed Common Data Write Permission",
                    "type": "array"
                },
                "needed_resident_data_read_permission": {
                    "items": {
                        "format": "integer",
                        "title": "needed_resident_data_read_permission",
                        "type": "number"
                    },
                    "title": "Needed Resident Data Read Permission",
                    "type": "array"
                },
                "needed_resident_data_write_permission": {
                    "items": {
                        "format": "integer",
                        "title": "needed_resident_data_write_permission",
                        "type": "number"
                    },
                    "title": "Needed Resident Data Write Permission",
                    "type": "array"
                },
                "next_property_config_scan_timestamp": {
                    "format": "date-time",
                    "title": "Next Property Config Scan Timestamp",
                    "type": "string"
                },
                "notes_uid": {
                    "reference_type": "uuid",
                    "title": "Notes Uid",
                    "type": "string",
                    "uid_resource_type": "resource_note"
                },
                "push_updates_to_resident_custom_columns": {
                    "title": "Push Updates To Resident Custom Columns",
                    "type": "boolean"
                },
                "push_updates_to_resident_pets": {
                    "title": "Push Updates To Resident Pets",
                    "type": "boolean"
                },
                "push_updates_to_resident_vehicles": {
                    "title": "Push Updates To Resident Vehicles",
                    "type": "boolean"
                },
                "push_updates_via_ils_guest_card_events": {
                    "title": "Push Updates Via Ils Guest Card Events",
                    "type": "boolean"
                },
                "resident_custom_columns_uid_list": {
                    "items": {
                        "title": "resident_custom_columns_uid_list",
                        "type": "string"
                    },
                    "title": "Resident Custom Columns Uid List",
                    "type": "array"
                },
                "scan_hour_step_for_get_property_config": {
                    "format": "integer",
                    "title": "Scan Hour Step For Get Property Config",
                    "type": "number"
                },
                "scan_hour_step_for_get_tenant_status": {
                    "format": "integer",
                    "title": "Scan Hour Step For Get Tenant Status",
                    "type": "number"
                },
                "scan_hour_step_for_get_unit_information": {
                    "format": "integer",
                    "title": "Scan Hour Step For Get Unit Information",
                    "type": "number"
                },
                "scan_hour_step_for_ils_guest_activity": {
                    "format": "integer",
                    "title": "Scan Hour Step For Ils Guest Activity",
                    "type": "number"
                },
                "scan_utc_hour_start": {
                    "format": "integer",
                    "title": "Scan Utc Hour Start",
                    "type": "number"
                },
                "scan_utc_hour_stop": {
                    "format": "integer",
                    "title": "Scan Utc Hour Stop",
                    "type": "number"
                },
                "state": {
                    "class_name": "YardiVoyagerPMCState",
                    "enum": [
                        "awaiting_set_up",
                        "enabled",
                        "disabled"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "version": {
                    "maxLength": 10,
                    "minLength": 1,
                    "title": "Version",
                    "type": "string"
                }
            },
            "required": [
                "allow_get_tenant_status_checks",
                "allow_ils_guest_card_activity_checks",
                "allow_permission_checks",
                "allow_property_configuration_checks",
                "allow_unit_information_checks",
                "deposify_pmc_account_uid",
                "error_codes",
                "has_custom_columns",
                "last_permission_check_timestamp",
                "last_property_config_scan_timestamp",
                "needed_common_data_read_permission",
                "needed_common_data_write_permission",
                "needed_resident_data_read_permission",
                "needed_resident_data_write_permission",
                "next_property_config_scan_timestamp",
                "push_updates_to_resident_custom_columns",
                "push_updates_to_resident_pets",
                "push_updates_to_resident_vehicles",
                "push_updates_via_ils_guest_card_events",
                "resident_custom_columns_uid_list",
                "scan_hour_step_for_get_property_config",
                "scan_hour_step_for_get_tenant_status",
                "scan_hour_step_for_get_unit_information",
                "scan_hour_step_for_ils_guest_activity",
                "scan_utc_hour_start",
                "scan_utc_hour_stop",
                "state",
                "version"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _YARDI_VOYAGER_PMC_CREDENTIALS_JSON_SCHEMA = {
    "$ref": "#/definitions/YardiVoyagerPMCCredentialsSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "YardiVoyagerPMCCredentialsSchema": {
            "additionalProperties": false,
            "properties": {
                "base_url": {
                    "title": "Base Url",
                    "type": "string"
                },
                "common_data_database": {
                    "title": "Common Data Database",
                    "type": "string"
                },
                "common_data_password": {
                    "title": "Common Data Password",
                    "type": "string"
                },
                "common_data_platform": {
                    "title": "Common Data Platform",
                    "type": "string"
                },
                "common_data_server_name": {
                    "title": "Common Data Server Name",
                    "type": "string"
                },
                "common_data_username": {
                    "title": "Common Data Username",
                    "type": "string"
                },
                "common_data_wsdl_service_url": {
                    "title": "Common Data Wsdl Service Url",
                    "type": "string"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "deposify_pmc_account_uid": {
                    "reference_type": "uuid",
                    "title": "Deposify Pmc Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "deposify_tags": {
                    "items": {
                        "format": "integer",
                        "title": "deposify_tags",
                        "type": "number"
                    },
                    "title": "Deposify Tags",
                    "type": "array"
                },
                "ils_guest_database": {
                    "title": "Ils Guest Database",
                    "type": "string"
                },
                "ils_guest_password": {
                    "title": "Ils Guest Password",
                    "type": "string"
                },
                "ils_guest_platform": {
                    "title": "Ils Guest Platform",
                    "type": "string"
                },
                "ils_guest_server_name": {
                    "title": "Ils Guest Server Name",
                    "type": "string"
                },
                "ils_guest_username": {
                    "title": "Ils Guest Username",
                    "type": "string"
                },
                "ils_guest_wsdl_service_url": {
                    "title": "Ils Guest Wsdl Service Url",
                    "type": "string"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "notes_uid": {
                    "reference_type": "uuid",
                    "title": "Notes Uid",
                    "type": "string",
                    "uid_resource_type": "resource_note"
                },
                "res_data_database": {
                    "title": "Res Data Database",
                    "type": "string"
                },
                "res_data_password": {
                    "title": "Res Data Password",
                    "type": "string"
                },
                "res_data_platform": {
                    "title": "Res Data Platform",
                    "type": "string"
                },
                "res_data_server_name": {
                    "title": "Res Data Server Name",
                    "type": "string"
                },
                "res_data_username": {
                    "title": "Res Data Username",
                    "type": "string"
                },
                "res_data_wsdl_service_url": {
                    "title": "Res Data Wsdl Service Url",
                    "type": "string"
                },
                "res_transact_database": {
                    "title": "Res Transact Database",
                    "type": "string"
                },
                "res_transact_password": {
                    "title": "Res Transact Password",
                    "type": "string"
                },
                "res_transact_platform": {
                    "title": "Res Transact Platform",
                    "type": "string"
                },
                "res_transact_server_name": {
                    "title": "Res Transact Server Name",
                    "type": "string"
                },
                "res_transact_username": {
                    "title": "Res Transact Username",
                    "type": "string"
                },
                "res_transact_wsdl_service_url": {
                    "title": "Res Transact Wsdl Service Url",
                    "type": "string"
                },
                "version": {
                    "maxLength": 10,
                    "minLength": 1,
                    "title": "Version",
                    "type": "string"
                }
            },
            "required": [
                "base_url",
                "common_data_database",
                "common_data_password",
                "common_data_platform",
                "common_data_server_name",
                "common_data_username",
                "common_data_wsdl_service_url",
                "deposify_pmc_account_uid",
                "ils_guest_database",
                "ils_guest_password",
                "ils_guest_platform",
                "ils_guest_server_name",
                "ils_guest_username",
                "ils_guest_wsdl_service_url",
                "res_data_database",
                "res_data_password",
                "res_data_platform",
                "res_data_server_name",
                "res_data_username",
                "res_data_wsdl_service_url",
                "res_transact_database",
                "res_transact_password",
                "res_transact_platform",
                "res_transact_server_name",
                "res_transact_username",
                "res_transact_wsdl_service_url",
                "version"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _YARDI_VOYAGER_PMC_CUSTOM_COLUMN_SETTINGS_JSON_SCHEMA = {
    "$ref": "#/definitions/YardiVoyagerPMCCustomColumnSettingsSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "YardiVoyagerPMCCustomColumnSettingsSchema": {
            "additionalProperties": false,
            "properties": {
                "column_name": {
                    "title": "Column Name",
                    "type": "string"
                },
                "column_type": {
                    "class_name": "YardiVoyagerCustomColumnType",
                    "enum": [
                        "deposify_deposit_state",
                        "deposify_link",
                        "deposify_deposit_state_and_link"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "column_uid": {
                    "reference_type": "uuid",
                    "title": "Column Uid",
                    "type": "string",
                    "uid_resource_type": "yardi_voyager_pmc_custom_column_settings"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "deposify_pmc_account_uid": {
                    "reference_type": "uuid",
                    "title": "Deposify Pmc Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "deposify_tags": {
                    "items": {
                        "format": "integer",
                        "title": "deposify_tags",
                        "type": "number"
                    },
                    "title": "Deposify Tags",
                    "type": "array"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "notes_uid": {
                    "reference_type": "uuid",
                    "title": "Notes Uid",
                    "type": "string",
                    "uid_resource_type": "resource_note"
                },
                "version": {
                    "maxLength": 10,
                    "minLength": 1,
                    "title": "Version",
                    "type": "string"
                }
            },
            "required": [
                "column_name",
                "column_type",
                "column_uid",
                "deposify_pmc_account_uid",
                "version"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _YARDI_VOYAGER_PMC_SERVICE_INTERFACE_VERSION_JSON_SCHEMA = {
    "$ref": "#/definitions/YardiVoyagerPMCServiceInterfaceVersionSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "YardiVoyagerPMCServiceInterfaceVersionSchema": {
            "additionalProperties": false,
            "properties": {
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "deposify_pmc_account_uid": {
                    "reference_type": "uuid",
                    "title": "Deposify Pmc Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "deposify_tags": {
                    "items": {
                        "format": "integer",
                        "title": "deposify_tags",
                        "type": "number"
                    },
                    "title": "Deposify Tags",
                    "type": "array"
                },
                "first_seen_timestamp": {
                    "format": "date-time",
                    "title": "First Seen Timestamp",
                    "type": "string"
                },
                "last_checked_timestamp": {
                    "format": "date-time",
                    "title": "Last Checked Timestamp",
                    "type": "string"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "notes_uid": {
                    "reference_type": "uuid",
                    "title": "Notes Uid",
                    "type": "string",
                    "uid_resource_type": "resource_note"
                },
                "service_interface_version_uid": {
                    "reference_type": "uuid",
                    "title": "Service Interface Version Uid",
                    "type": "string",
                    "uid_resource_type": "yardi_voyager_pmc_service_interface_version"
                },
                "state": {
                    "class_name": "YardiVoyagerInterfaceVersionState",
                    "enum": [
                        "supported",
                        "version_too_low"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "version": {
                    "maxLength": 10,
                    "minLength": 1,
                    "title": "Version",
                    "type": "string"
                },
                "voyager_core_app_version": {
                    "title": "Voyager Core App Version",
                    "type": "string"
                },
                "voyager_core_interface_version": {
                    "title": "Voyager Core Interface Version",
                    "type": "string"
                },
                "voyager_plugin_version": {
                    "title": "Voyager Plugin Version",
                    "type": "string"
                }
            },
            "required": [
                "deposify_pmc_account_uid",
                "first_seen_timestamp",
                "last_checked_timestamp",
                "service_interface_version_uid",
                "state",
                "version",
                "voyager_core_app_version",
                "voyager_core_interface_version",
                "voyager_plugin_version"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _YARDI_VOYAGER_PMC_STATS_JSON_SCHEMA = {
    "$ref": "#/definitions/YardiVoyagerPMCStatsSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "YardiVoyagerPMCStatsSchema": {
            "additionalProperties": false,
            "properties": {
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "deposify_pmc_account_uid": {
                    "reference_type": "uuid",
                    "title": "Deposify Pmc Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "deposify_tags": {
                    "items": {
                        "format": "integer",
                        "title": "deposify_tags",
                        "type": "number"
                    },
                    "title": "Deposify Tags",
                    "type": "array"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "notes_uid": {
                    "reference_type": "uuid",
                    "title": "Notes Uid",
                    "type": "string",
                    "uid_resource_type": "resource_note"
                },
                "stats_date": {
                    "format": "date-time",
                    "title": "Stats Date",
                    "type": "string"
                },
                "stats_json": {
                    "additionalProperties": {},
                    "title": "Stats Json",
                    "type": "object"
                },
                "stats_uid": {
                    "reference_type": "uuid",
                    "title": "Stats Uid",
                    "type": "string",
                    "uid_resource_type": "yardi_voyager_pmc_stats"
                },
                "version": {
                    "maxLength": 10,
                    "minLength": 1,
                    "title": "Version",
                    "type": "string"
                }
            },
            "required": [
                "deposify_pmc_account_uid",
                "stats_date",
                "stats_json",
                "stats_uid",
                "version"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _YARDI_VOYAGER_PMC_STATS_COLLECTOR_JSON_SCHEMA = {
    "$ref": "#/definitions/YardiVoyagerPMCStatsCollectorSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "YardiVoyagerPMCStatsCollectorSchema": {
            "additionalProperties": false,
            "properties": {
                "combo_stats_uid": {
                    "reference_type": "uuid",
                    "title": "Combo Stats Uid",
                    "type": "string",
                    "uid_resource_type": "yardi_voyager_pmc_stats"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "delete_after_timestamp": {
                    "format": "date-time",
                    "title": "Delete After Timestamp",
                    "type": "string"
                },
                "deposify_pmc_account_uid": {
                    "reference_type": "uuid",
                    "title": "Deposify Pmc Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "deposify_tags": {
                    "items": {
                        "format": "integer",
                        "title": "deposify_tags",
                        "type": "number"
                    },
                    "title": "Deposify Tags",
                    "type": "array"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "notes_uid": {
                    "reference_type": "uuid",
                    "title": "Notes Uid",
                    "type": "string",
                    "uid_resource_type": "resource_note"
                },
                "stats_date": {
                    "format": "date-time",
                    "title": "Stats Date",
                    "type": "string"
                },
                "stats_json": {
                    "additionalProperties": {},
                    "title": "Stats Json",
                    "type": "object"
                },
                "stats_uid": {
                    "reference_type": "uuid",
                    "title": "Stats Uid",
                    "type": "string",
                    "uid_resource_type": "yardi_voyager_pmc_stats_collector"
                },
                "version": {
                    "maxLength": 10,
                    "minLength": 1,
                    "title": "Version",
                    "type": "string"
                }
            },
            "required": [
                "combo_stats_uid",
                "delete_after_timestamp",
                "deposify_pmc_account_uid",
                "stats_date",
                "stats_json",
                "stats_uid",
                "version"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _YARDI_VOYAGER_PROPERTY_JSON_SCHEMA = {
    "$ref": "#/definitions/YardiVoyagerPropertySchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "YardiVoyagerPropertySchema": {
            "additionalProperties": false,
            "properties": {
                "account_uids_with_read_permission": {
                    "items": {
                        "title": "account_uids_with_read_permission",
                        "type": "string"
                    },
                    "reference_type": "uuid",
                    "title": "Account Uids With Read Permission",
                    "type": "array",
                    "uid_resource_type": "user_account"
                },
                "allow_get_tenant_status_checks": {
                    "title": "Allow Get Tenant Status Checks",
                    "type": "boolean"
                },
                "allow_ils_guest_card_activity_checks": {
                    "title": "Allow Ils Guest Card Activity Checks",
                    "type": "boolean"
                },
                "allow_unit_information_checks": {
                    "title": "Allow Unit Information Checks",
                    "type": "boolean"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "deposify_pmc_account_uid": {
                    "reference_type": "uuid",
                    "title": "Deposify Pmc Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "deposify_property_uid": {
                    "reference_type": "uuid",
                    "title": "Deposify Property Uid",
                    "type": "string",
                    "uid_resource_type": "property"
                },
                "deposify_tags": {
                    "items": {
                        "format": "integer",
                        "title": "deposify_tags",
                        "type": "number"
                    },
                    "title": "Deposify Tags",
                    "type": "array"
                },
                "initial_ils_guest_card_activity_scan_day_count": {
                    "format": "integer",
                    "title": "Initial Ils Guest Card Activity Scan Day Count",
                    "type": "number"
                },
                "initial_ils_guest_card_activity_scan_timestamp": {
                    "format": "date-time",
                    "title": "Initial Ils Guest Card Activity Scan Timestamp",
                    "type": "string"
                },
                "last_get_tenant_status_scan_timestamp": {
                    "format": "date-time",
                    "title": "Last Get Tenant Status Scan Timestamp",
                    "type": "string"
                },
                "last_ils_guest_card_activity_check_timestamp": {
                    "format": "date-time",
                    "title": "Last Ils Guest Card Activity Check Timestamp",
                    "type": "string"
                },
                "last_roommate_promotion_check_timestamp": {
                    "format": "date-time",
                    "title": "Last Roommate Promotion Check Timestamp",
                    "type": "string"
                },
                "last_unit_information_scan_timestamp": {
                    "format": "date-time",
                    "title": "Last Unit Information Scan Timestamp",
                    "type": "string"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "marketing_name": {
                    "maxLength": 120,
                    "title": "Marketing Name",
                    "type": "string"
                },
                "next_get_tenant_status_scan_timestamp": {
                    "format": "date-time",
                    "title": "Next Get Tenant Status Scan Timestamp",
                    "type": "string"
                },
                "next_ils_guest_card_activity_check_timestamp": {
                    "format": "date-time",
                    "title": "Next Ils Guest Card Activity Check Timestamp",
                    "type": "string"
                },
                "next_unit_information_scan_timestamp": {
                    "format": "date-time",
                    "title": "Next Unit Information Scan Timestamp",
                    "type": "string"
                },
                "notes_uid": {
                    "reference_type": "uuid",
                    "title": "Notes Uid",
                    "type": "string",
                    "uid_resource_type": "resource_note"
                },
                "organization_uids_with_read_permission": {
                    "items": {
                        "title": "organization_uids_with_read_permission",
                        "type": "string"
                    },
                    "reference_type": "uuid",
                    "title": "Organization Uids With Read Permission",
                    "type": "array",
                    "uid_resource_type": "user_account"
                },
                "pmc_resource_creating_account_uid": {
                    "reference_type": "uuid",
                    "title": "Pmc Resource Creating Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "property_details_hash": {
                    "title": "Property Details Hash",
                    "type": "string"
                },
                "property_details_need_refreshing": {
                    "title": "Property Details Need Refreshing",
                    "type": "boolean"
                },
                "state": {
                    "class_name": "YardiVoyagerPropertyState",
                    "enum": [
                        "awaiting_initial_setup",
                        "awaiting_initial_unit_scan",
                        "active",
                        "pmc_disabled",
                        "admin_disabled",
                        "awaiting_removal_inspection",
                        "missing_from_config_needs_to_be_added_back",
                        "disabled_due_to_removal_from_config"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "version": {
                    "maxLength": 10,
                    "minLength": 1,
                    "title": "Version",
                    "type": "string"
                },
                "voyager_property_code": {
                    "title": "Voyager Property Code",
                    "type": "string"
                },
                "voyager_property_id": {
                    "maxLength": 256,
                    "title": "Voyager Property Id",
                    "type": "string"
                },
                "voyager_property_uid": {
                    "reference_type": "uuid",
                    "title": "Voyager Property Uid",
                    "type": "string",
                    "uid_resource_type": "yardi_voyager_property"
                }
            },
            "required": [
                "allow_get_tenant_status_checks",
                "allow_ils_guest_card_activity_checks",
                "allow_unit_information_checks",
                "deposify_pmc_account_uid",
                "deposify_property_uid",
                "initial_ils_guest_card_activity_scan_day_count",
                "initial_ils_guest_card_activity_scan_timestamp",
                "last_get_tenant_status_scan_timestamp",
                "last_ils_guest_card_activity_check_timestamp",
                "last_roommate_promotion_check_timestamp",
                "last_unit_information_scan_timestamp",
                "marketing_name",
                "next_get_tenant_status_scan_timestamp",
                "next_ils_guest_card_activity_check_timestamp",
                "next_unit_information_scan_timestamp",
                "pmc_resource_creating_account_uid",
                "property_details_hash",
                "property_details_need_refreshing",
                "state",
                "version",
                "voyager_property_code",
                "voyager_property_id",
                "voyager_property_uid"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _YARDI_VOYAGER_PROPERTY_UNIT_JSON_SCHEMA = {
    "$ref": "#/definitions/YardiVoyagerPropertyUnitSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "YardiVoyagerPropertyUnitSchema": {
            "additionalProperties": false,
            "properties": {
                "account_uids_with_read_permission": {
                    "items": {
                        "title": "account_uids_with_read_permission",
                        "type": "string"
                    },
                    "reference_type": "uuid",
                    "title": "Account Uids With Read Permission",
                    "type": "array",
                    "uid_resource_type": "user_account"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "creation_source": {
                    "class_name": "YardiVoyagerPropertyUnitDataSource",
                    "enum": [
                        "ils_guest_card_customer",
                        "resident_data",
                        "unit_information"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "deposify_pmc_account_uid": {
                    "reference_type": "uuid",
                    "title": "Deposify Pmc Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "deposify_property_uid": {
                    "reference_type": "uuid",
                    "title": "Deposify Property Uid",
                    "type": "string",
                    "uid_resource_type": "property"
                },
                "deposify_tags": {
                    "items": {
                        "format": "integer",
                        "title": "deposify_tags",
                        "type": "number"
                    },
                    "title": "Deposify Tags",
                    "type": "array"
                },
                "last_update_source": {
                    "class_name": "YardiVoyagerPropertyUnitDataSource",
                    "enum": [
                        "ils_guest_card_customer",
                        "resident_data",
                        "unit_information"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "market_rent_in_cents": {
                    "cents_value": true,
                    "format": "integer",
                    "maximum": 9223372036854775807,
                    "minimum": 0,
                    "title": "Market Rent In Cents",
                    "type": "number"
                },
                "notes_uid": {
                    "reference_type": "uuid",
                    "title": "Notes Uid",
                    "type": "string",
                    "uid_resource_type": "resource_note"
                },
                "organization_uids_with_read_permission": {
                    "items": {
                        "title": "organization_uids_with_read_permission",
                        "type": "string"
                    },
                    "reference_type": "uuid",
                    "title": "Organization Uids With Read Permission",
                    "type": "array",
                    "uid_resource_type": "user_account"
                },
                "unit_details_hash": {
                    "title": "Unit Details Hash",
                    "type": "string"
                },
                "version": {
                    "maxLength": 10,
                    "minLength": 1,
                    "title": "Version",
                    "type": "string"
                },
                "voyager_parent_property_uid": {
                    "reference_type": "uuid",
                    "title": "Voyager Parent Property Uid",
                    "type": "string",
                    "uid_resource_type": "yardi_voyager_property"
                },
                "voyager_property_unit_id": {
                    "maxLength": 256,
                    "title": "Voyager Property Unit Id",
                    "type": "string"
                },
                "voyager_property_unit_uid": {
                    "reference_type": "uuid",
                    "title": "Voyager Property Unit Uid",
                    "type": "string",
                    "uid_resource_type": "yardi_voyager_property_unit"
                },
                "voyager_property_unit_unique_id": {
                    "maxLength": 256,
                    "title": "Voyager Property Unit Unique Id",
                    "type": "string"
                }
            },
            "required": [
                "creation_source",
                "deposify_pmc_account_uid",
                "deposify_property_uid",
                "last_update_source",
                "market_rent_in_cents",
                "unit_details_hash",
                "version",
                "voyager_parent_property_uid",
                "voyager_property_unit_id",
                "voyager_property_unit_uid",
                "voyager_property_unit_unique_id"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _YARDI_VOYAGER_RESIDENT_JSON_SCHEMA = {
    "$ref": "#/definitions/YardiVoyagerResidentSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "YardiVoyagerResidentSchema": {
            "additionalProperties": false,
            "properties": {
                "account_uids_with_read_permission": {
                    "items": {
                        "title": "account_uids_with_read_permission",
                        "type": "string"
                    },
                    "reference_type": "uuid",
                    "title": "Account Uids With Read Permission",
                    "type": "array",
                    "uid_resource_type": "user_account"
                },
                "check_intents_on_status_change": {
                    "title": "Check Intents On Status Change",
                    "type": "boolean"
                },
                "close_deposit_intent_uid": {
                    "title": "Close Deposit Intent Uid",
                    "type": "string"
                },
                "create_deposit_intent_is_for_roommate_promotion": {
                    "title": "Create Deposit Intent Is For Roommate Promotion",
                    "type": "boolean"
                },
                "create_deposit_intent_uid": {
                    "title": "Create Deposit Intent Uid",
                    "type": "string"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "creation_source": {
                    "class_name": "YardiVoyagerResidentDataSource",
                    "enum": [
                        "ils_guest_card_customer",
                        "resident_data"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "deposify_deposit_uid": {
                    "reference_type": "uuid",
                    "title": "Deposify Deposit Uid",
                    "type": "string",
                    "uid_resource_type": "deposit"
                },
                "deposify_pmc_account_uid": {
                    "reference_type": "uuid",
                    "title": "Deposify Pmc Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "deposify_tags": {
                    "items": {
                        "format": "integer",
                        "title": "deposify_tags",
                        "type": "number"
                    },
                    "title": "Deposify Tags",
                    "type": "array"
                },
                "deposify_tenant_account_uid": {
                    "reference_type": "uuid",
                    "title": "Deposify Tenant Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "email_address": {
                    "title": "Email Address",
                    "type": "string"
                },
                "email_hash": {
                    "title": "Email Hash",
                    "type": "string"
                },
                "first_name": {
                    "title": "First Name",
                    "type": "string"
                },
                "flex_deposit_intent_uid": {
                    "title": "Flex Deposit Intent Uid",
                    "type": "string"
                },
                "has_other_occupants": {
                    "title": "Has Other Occupants",
                    "type": "boolean"
                },
                "last_drop_from_status_list_timestamp": {
                    "format": "date-time",
                    "title": "Last Drop From Status List Timestamp",
                    "type": "string"
                },
                "last_name": {
                    "title": "Last Name",
                    "type": "string"
                },
                "last_status_change_timestamp": {
                    "format": "date-time",
                    "title": "Last Status Change Timestamp",
                    "type": "string"
                },
                "last_update_source": {
                    "class_name": "YardiVoyagerResidentDataSource",
                    "enum": [
                        "ils_guest_card_customer",
                        "resident_data"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "last_voyager_ils_guest_card_event_uid": {
                    "reference_type": "uuid",
                    "title": "Last Voyager Ils Guest Card Event Uid",
                    "type": "string",
                    "uid_resource_type": "yardi_voyager_ils_guest_card_event"
                },
                "last_voyager_pet_uid": {
                    "reference_type": "uuid",
                    "title": "Last Voyager Pet Uid",
                    "type": "string",
                    "uid_resource_type": "yardi_voyager_pet"
                },
                "last_voyager_resident_status_check_timestamp": {
                    "format": "date-time",
                    "title": "Last Voyager Resident Status Check Timestamp",
                    "type": "string"
                },
                "lease_begin_timestamp": {
                    "format": "date-time",
                    "title": "Lease Begin Timestamp",
                    "type": "string"
                },
                "lease_end_timestamp": {
                    "format": "date-time",
                    "title": "Lease End Timestamp",
                    "type": "string"
                },
                "missing_data_list": {
                    "items": {
                        "class_name": "YardiVoyagerDataType",
                        "enum": [
                            "phone",
                            "email",
                            "first_name",
                            "last_name",
                            "prospect_code",
                            "tenant_code"
                        ],
                        "reference_type": "enum",
                        "type": "string"
                    },
                    "title": "Missing Data List",
                    "type": "array"
                },
                "move_in_timestamp": {
                    "format": "date-time",
                    "title": "Move In Timestamp",
                    "type": "string"
                },
                "move_out_timestamp": {
                    "format": "date-time",
                    "title": "Move Out Timestamp",
                    "type": "string"
                },
                "notes_uid": {
                    "reference_type": "uuid",
                    "title": "Notes Uid",
                    "type": "string",
                    "uid_resource_type": "resource_note"
                },
                "organization_uids_with_read_permission": {
                    "items": {
                        "title": "organization_uids_with_read_permission",
                        "type": "string"
                    },
                    "reference_type": "uuid",
                    "title": "Organization Uids With Read Permission",
                    "type": "array",
                    "uid_resource_type": "user_account"
                },
                "previous_voyager_resident_status": {
                    "class_name": "YardiVoyagerResidentStatus",
                    "enum": [
                        "current",
                        "past",
                        "future",
                        "moved out",
                        "notice",
                        "on notice",
                        "eviction",
                        "other",
                        "guest",
                        "canceled guest",
                        "customer",
                        "resident",
                        "current resident",
                        "former resident",
                        "future resident",
                        "prospect",
                        "roommate",
                        "spouse",
                        "guarantor",
                        "applicant",
                        "approved applicant",
                        "denied applicant",
                        "applied",
                        "approved",
                        "denied",
                        "cancelled",
                        "canceled",
                        "waitlist",
                        "vacant"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "rent_in_cents": {
                    "cents_value": true,
                    "format": "integer",
                    "maximum": 9223372036854775807,
                    "minimum": 0,
                    "title": "Rent In Cents",
                    "type": "number"
                },
                "state": {
                    "class_name": "YardiVoyagerResidentState",
                    "enum": [
                        "new_resident_initial_seed",
                        "details_need_refreshing",
                        "needs_processing",
                        "okay",
                        "error"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "transferred_to_deposify_deposit_uid": {
                    "reference_type": "uuid",
                    "title": "Transferred To Deposify Deposit Uid",
                    "type": "string",
                    "uid_resource_type": "deposit"
                },
                "version": {
                    "maxLength": 10,
                    "minLength": 1,
                    "title": "Version",
                    "type": "string"
                },
                "voyager_property_uid": {
                    "reference_type": "uuid",
                    "title": "Voyager Property Uid",
                    "type": "string",
                    "uid_resource_type": "yardi_voyager_property"
                },
                "voyager_property_unit_id": {
                    "maxLength": 256,
                    "title": "Voyager Property Unit Id",
                    "type": "string"
                },
                "voyager_property_unit_uid": {
                    "reference_type": "uuid",
                    "title": "Voyager Property Unit Uid",
                    "type": "string",
                    "uid_resource_type": "yardi_voyager_property_unit"
                },
                "voyager_prospect_code": {
                    "title": "Voyager Prospect Code",
                    "type": "string"
                },
                "voyager_resident_status": {
                    "class_name": "YardiVoyagerResidentStatus",
                    "enum": [
                        "current",
                        "past",
                        "future",
                        "moved out",
                        "notice",
                        "on notice",
                        "eviction",
                        "other",
                        "guest",
                        "canceled guest",
                        "customer",
                        "resident",
                        "current resident",
                        "former resident",
                        "future resident",
                        "prospect",
                        "roommate",
                        "spouse",
                        "guarantor",
                        "applicant",
                        "approved applicant",
                        "denied applicant",
                        "applied",
                        "approved",
                        "denied",
                        "cancelled",
                        "canceled",
                        "waitlist",
                        "vacant"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "voyager_resident_uid": {
                    "reference_type": "uuid",
                    "title": "Voyager Resident Uid",
                    "type": "string",
                    "uid_resource_type": "yardi_voyager_resident"
                },
                "voyager_tenant_code": {
                    "title": "Voyager Tenant Code",
                    "type": "string"
                }
            },
            "required": [
                "check_intents_on_status_change",
                "close_deposit_intent_uid",
                "create_deposit_intent_is_for_roommate_promotion",
                "create_deposit_intent_uid",
                "creation_source",
                "deposify_deposit_uid",
                "deposify_pmc_account_uid",
                "deposify_tenant_account_uid",
                "email_address",
                "email_hash",
                "first_name",
                "flex_deposit_intent_uid",
                "has_other_occupants",
                "last_drop_from_status_list_timestamp",
                "last_name",
                "last_status_change_timestamp",
                "last_update_source",
                "last_voyager_ils_guest_card_event_uid",
                "last_voyager_pet_uid",
                "last_voyager_resident_status_check_timestamp",
                "lease_begin_timestamp",
                "lease_end_timestamp",
                "missing_data_list",
                "move_in_timestamp",
                "move_out_timestamp",
                "previous_voyager_resident_status",
                "rent_in_cents",
                "state",
                "transferred_to_deposify_deposit_uid",
                "version",
                "voyager_property_uid",
                "voyager_property_unit_id",
                "voyager_property_unit_uid",
                "voyager_prospect_code",
                "voyager_resident_status",
                "voyager_resident_uid",
                "voyager_tenant_code"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _YARDI_VOYAGER_RESIDENT_CUSTOM_COLUMN_JSON_SCHEMA = {
    "$ref": "#/definitions/YardiVoyagerResidentCustomColumnSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "YardiVoyagerResidentCustomColumnSchema": {
            "additionalProperties": false,
            "properties": {
                "column_name": {
                    "title": "Column Name",
                    "type": "string"
                },
                "column_type": {
                    "class_name": "YardiVoyagerCustomColumnType",
                    "enum": [
                        "deposify_deposit_state",
                        "deposify_link",
                        "deposify_deposit_state_and_link"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "current_column_value": {
                    "title": "Current Column Value",
                    "type": "string"
                },
                "custom_column_uid": {
                    "reference_type": "uuid",
                    "title": "Custom Column Uid",
                    "type": "string",
                    "uid_resource_type": "yardi_voyager_resident_custom_column"
                },
                "deposify_tags": {
                    "items": {
                        "format": "integer",
                        "title": "deposify_tags",
                        "type": "number"
                    },
                    "title": "Deposify Tags",
                    "type": "array"
                },
                "last_update_failure_timestamp": {
                    "format": "date-time",
                    "title": "Last Update Failure Timestamp",
                    "type": "string"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "notes_uid": {
                    "reference_type": "uuid",
                    "title": "Notes Uid",
                    "type": "string",
                    "uid_resource_type": "resource_note"
                },
                "state": {
                    "class_name": "YardiVoyagerResidentCustomColumnState",
                    "enum": [
                        "okay",
                        "awaiting_push_to_voyager",
                        "unsent_due_to_pmc_or_resident",
                        "unsent_due_to_too_many_failures"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "update_failure_count": {
                    "format": "integer",
                    "title": "Update Failure Count",
                    "type": "number"
                },
                "version": {
                    "maxLength": 10,
                    "minLength": 1,
                    "title": "Version",
                    "type": "string"
                },
                "voyager_resident_uid": {
                    "reference_type": "uuid",
                    "title": "Voyager Resident Uid",
                    "type": "string",
                    "uid_resource_type": "yardi_voyager_resident"
                }
            },
            "required": [
                "column_name",
                "column_type",
                "current_column_value",
                "custom_column_uid",
                "last_update_failure_timestamp",
                "state",
                "update_failure_count",
                "version",
                "voyager_resident_uid"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _YARDI_VOYAGER_SYSTEM_SETTINGS_JSON_SCHEMA = {
    "$ref": "#/definitions/YardiVoyagerSystemSettingsSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "YardiVoyagerSystemSettingsSchema": {
            "additionalProperties": false,
            "properties": {
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "deposify_tags": {
                    "items": {
                        "format": "integer",
                        "title": "deposify_tags",
                        "type": "number"
                    },
                    "title": "Deposify Tags",
                    "type": "array"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "notes_uid": {
                    "reference_type": "uuid",
                    "title": "Notes Uid",
                    "type": "string",
                    "uid_resource_type": "resource_note"
                },
                "settings_uid": {
                    "reference_type": "uuid",
                    "title": "Settings Uid",
                    "type": "string",
                    "uid_resource_type": "yardi_voyager_system_settings"
                },
                "voyager_enabled": {
                    "title": "Voyager Enabled",
                    "type": "boolean"
                }
            },
            "required": [
                "settings_uid",
                "voyager_enabled"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _YARDI_VOYAGER_TRANSACTION_JSON_SCHEMA = {
    "$ref": "#/definitions/YardiVoyagerTransactionSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "YardiVoyagerTransactionSchema": {
            "additionalProperties": false,
            "properties": {
                "admin_error_info": {
                    "title": "Admin Error Info",
                    "type": "string"
                },
                "charge_amount_in_cents": {
                    "cents_value": true,
                    "format": "integer",
                    "maximum": 9223372036854775807,
                    "minimum": 0,
                    "title": "Charge Amount In Cents",
                    "type": "number"
                },
                "charge_code_string": {
                    "maxLength": 8,
                    "title": "Charge Code String",
                    "type": "string"
                },
                "charge_code_uid": {
                    "reference_type": "uuid",
                    "title": "Charge Code Uid",
                    "type": "string",
                    "uid_resource_type": "yardi_voyager_charge_code"
                },
                "charge_comments": {
                    "title": "Charge Comments",
                    "type": "string"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "deposify_pmc_account_uid": {
                    "reference_type": "uuid",
                    "title": "Deposify Pmc Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "deposify_tags": {
                    "items": {
                        "format": "integer",
                        "title": "deposify_tags",
                        "type": "number"
                    },
                    "title": "Deposify Tags",
                    "type": "array"
                },
                "intent_type": {
                    "class_name": "YardiVoyagerChargeCodeIntent",
                    "enum": [
                        "deposify_security_deposit",
                        "deposify_pet_deposit",
                        "deposify_utility_deposit",
                        "deposify_close_deposit",
                        "deposify_withhold_deposit_funds"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "intent_uid": {
                    "title": "Intent Uid",
                    "type": "string"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "notes_uid": {
                    "reference_type": "uuid",
                    "title": "Notes Uid",
                    "type": "string",
                    "uid_resource_type": "resource_note"
                },
                "state": {
                    "class_name": "YardiVoyagerTransactionState",
                    "enum": [
                        "awaiting_processing",
                        "converted_to_deposit_intent",
                        "abandoned"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "version": {
                    "maxLength": 10,
                    "minLength": 1,
                    "title": "Version",
                    "type": "string"
                },
                "voyager_property_uid": {
                    "reference_type": "uuid",
                    "title": "Voyager Property Uid",
                    "type": "string",
                    "uid_resource_type": "yardi_voyager_property"
                },
                "voyager_property_unit_uid": {
                    "reference_type": "uuid",
                    "title": "Voyager Property Unit Uid",
                    "type": "string",
                    "uid_resource_type": "yardi_voyager_property_unit"
                },
                "voyager_resident_uid": {
                    "reference_type": "uuid",
                    "title": "Voyager Resident Uid",
                    "type": "string",
                    "uid_resource_type": "yardi_voyager_resident"
                },
                "voyager_transaction_code": {
                    "title": "Voyager Transaction Code",
                    "type": "string"
                },
                "voyager_transaction_uid": {
                    "reference_type": "uuid",
                    "title": "Voyager Transaction Uid",
                    "type": "string",
                    "uid_resource_type": "yardi_voyager_transaction"
                },
                "voyager_xml_uid": {
                    "reference_type": "uuid",
                    "title": "Voyager Xml Uid",
                    "type": "string",
                    "uid_resource_type": "yardi_voyager_xml"
                }
            },
            "required": [
                "admin_error_info",
                "charge_amount_in_cents",
                "charge_code_string",
                "charge_code_uid",
                "charge_comments",
                "deposify_pmc_account_uid",
                "intent_type",
                "intent_uid",
                "state",
                "version",
                "voyager_property_uid",
                "voyager_property_unit_uid",
                "voyager_resident_uid",
                "voyager_transaction_code",
                "voyager_transaction_uid",
                "voyager_xml_uid"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _YARDI_VOYAGER_XML_JSON_SCHEMA = {
    "$ref": "#/definitions/YardiVoyagerXMLSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "YardiVoyagerXMLSchema": {
            "additionalProperties": false,
            "properties": {
                "admin_error_message": {
                    "title": "Admin Error Message",
                    "type": "string"
                },
                "aws_bucket": {
                    "title": "Aws Bucket",
                    "type": "string"
                },
                "aws_file_path": {
                    "title": "Aws File Path",
                    "type": "string"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "deposify_pmc_account_uid": {
                    "reference_type": "uuid",
                    "title": "Deposify Pmc Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "deposify_tags": {
                    "items": {
                        "format": "integer",
                        "title": "deposify_tags",
                        "type": "number"
                    },
                    "title": "Deposify Tags",
                    "type": "array"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "notes_uid": {
                    "reference_type": "uuid",
                    "title": "Notes Uid",
                    "type": "string",
                    "uid_resource_type": "resource_note"
                },
                "process_after_timestamp": {
                    "format": "date-time",
                    "title": "Process After Timestamp",
                    "type": "string"
                },
                "state": {
                    "class_name": "YardiVoyagerXMLState",
                    "enum": [
                        "awaiting_processing",
                        "processed",
                        "has_errors"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "version": {
                    "maxLength": 10,
                    "minLength": 1,
                    "title": "Version",
                    "type": "string"
                },
                "voyager_property_uid": {
                    "reference_type": "uuid",
                    "title": "Voyager Property Uid",
                    "type": "string",
                    "uid_resource_type": "yardi_voyager_property"
                },
                "voyager_property_unit_uid": {
                    "reference_type": "uuid",
                    "title": "Voyager Property Unit Uid",
                    "type": "string",
                    "uid_resource_type": "yardi_voyager_property_unit"
                },
                "voyager_xml_uid": {
                    "reference_type": "uuid",
                    "title": "Voyager Xml Uid",
                    "type": "string",
                    "uid_resource_type": "yardi_voyager_xml"
                }
            },
            "required": [
                "admin_error_message",
                "aws_bucket",
                "aws_file_path",
                "deposify_pmc_account_uid",
                "process_after_timestamp",
                "state",
                "version",
                "voyager_property_uid",
                "voyager_property_unit_uid",
                "voyager_xml_uid"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};


export const YARDI_SCREENING_WORKS_PRO_XML_JSON_SCHEMA = _YARDI_SCREENING_WORKS_PRO_XML_JSON_SCHEMA.definitions.YardiScreeningWorksProXMLSchema;
export const YARDI_VOYAGER_ACTIVE_SCAN_LOG_ENTRY_JSON_SCHEMA = _YARDI_VOYAGER_ACTIVE_SCAN_LOG_ENTRY_JSON_SCHEMA.definitions.YardiVoyagerActiveScanLogEntrySchema;
export const YARDI_VOYAGER_CHARGE_JSON_SCHEMA = _YARDI_VOYAGER_CHARGE_JSON_SCHEMA.definitions.YardiVoyagerChargeSchema;
export const YARDI_VOYAGER_CHARGE_CODE_JSON_SCHEMA = _YARDI_VOYAGER_CHARGE_CODE_JSON_SCHEMA.definitions.YardiVoyagerChargeCodeSchema;
export const YARDI_VOYAGER_DEPOSIT_CLOSE_INTENT_JSON_SCHEMA = _YARDI_VOYAGER_DEPOSIT_CLOSE_INTENT_JSON_SCHEMA.definitions.YardiVoyagerDepositCloseIntentSchema;
export const YARDI_VOYAGER_DEPOSIT_CREATE_INTENT_JSON_SCHEMA = _YARDI_VOYAGER_DEPOSIT_CREATE_INTENT_JSON_SCHEMA.definitions.YardiVoyagerDepositCreateIntentSchema;
export const YARDI_VOYAGER_DEPOSIT_WITHHOLD_INTENT_JSON_SCHEMA = _YARDI_VOYAGER_DEPOSIT_WITHHOLD_INTENT_JSON_SCHEMA.definitions.YardiVoyagerDepositWithholdIntentSchema;
export const YARDI_VOYAGER_EVENT_JSON_SCHEMA = _YARDI_VOYAGER_EVENT_JSON_SCHEMA.definitions.YardiVoyagerEventSchema;
export const YARDI_VOYAGER_FLEX_DEPOSIT_INTENT_JSON_SCHEMA = _YARDI_VOYAGER_FLEX_DEPOSIT_INTENT_JSON_SCHEMA.definitions.YardiVoyagerFlexDepositIntentSchema;
export const YARDI_VOYAGER_ILS_GUEST_CARD_EVENT_JSON_SCHEMA = _YARDI_VOYAGER_ILS_GUEST_CARD_EVENT_JSON_SCHEMA.definitions.YardiVoyagerILSGuestCardEventSchema;
export const YARDI_VOYAGER_OTHER_OCCUPANT_JSON_SCHEMA = _YARDI_VOYAGER_OTHER_OCCUPANT_JSON_SCHEMA.definitions.YardiVoyagerOtherOccupantSchema;
export const YARDI_VOYAGER_PET_JSON_SCHEMA = _YARDI_VOYAGER_PET_JSON_SCHEMA.definitions.YardiVoyagerPetSchema;
export const YARDI_VOYAGER_PHONE_JSON_SCHEMA = _YARDI_VOYAGER_PHONE_JSON_SCHEMA.definitions.YardiVoyagerPhoneSchema;
export const YARDI_VOYAGER_PMC_JSON_SCHEMA = _YARDI_VOYAGER_PMC_JSON_SCHEMA.definitions.YardiVoyagerPMCSchema;
export const YARDI_VOYAGER_PMC_CREDENTIALS_JSON_SCHEMA = _YARDI_VOYAGER_PMC_CREDENTIALS_JSON_SCHEMA.definitions.YardiVoyagerPMCCredentialsSchema;
export const YARDI_VOYAGER_PMC_CUSTOM_COLUMN_SETTINGS_JSON_SCHEMA = _YARDI_VOYAGER_PMC_CUSTOM_COLUMN_SETTINGS_JSON_SCHEMA.definitions.YardiVoyagerPMCCustomColumnSettingsSchema;
export const YARDI_VOYAGER_PMC_SERVICE_INTERFACE_VERSION_JSON_SCHEMA = _YARDI_VOYAGER_PMC_SERVICE_INTERFACE_VERSION_JSON_SCHEMA.definitions.YardiVoyagerPMCServiceInterfaceVersionSchema;
export const YARDI_VOYAGER_PMC_STATS_JSON_SCHEMA = _YARDI_VOYAGER_PMC_STATS_JSON_SCHEMA.definitions.YardiVoyagerPMCStatsSchema;
export const YARDI_VOYAGER_PMC_STATS_COLLECTOR_JSON_SCHEMA = _YARDI_VOYAGER_PMC_STATS_COLLECTOR_JSON_SCHEMA.definitions.YardiVoyagerPMCStatsCollectorSchema;
export const YARDI_VOYAGER_PROPERTY_JSON_SCHEMA = _YARDI_VOYAGER_PROPERTY_JSON_SCHEMA.definitions.YardiVoyagerPropertySchema;
export const YARDI_VOYAGER_PROPERTY_UNIT_JSON_SCHEMA = _YARDI_VOYAGER_PROPERTY_UNIT_JSON_SCHEMA.definitions.YardiVoyagerPropertyUnitSchema;
export const YARDI_VOYAGER_RESIDENT_JSON_SCHEMA = _YARDI_VOYAGER_RESIDENT_JSON_SCHEMA.definitions.YardiVoyagerResidentSchema;
export const YARDI_VOYAGER_RESIDENT_CUSTOM_COLUMN_JSON_SCHEMA = _YARDI_VOYAGER_RESIDENT_CUSTOM_COLUMN_JSON_SCHEMA.definitions.YardiVoyagerResidentCustomColumnSchema;
export const YARDI_VOYAGER_SYSTEM_SETTINGS_JSON_SCHEMA = _YARDI_VOYAGER_SYSTEM_SETTINGS_JSON_SCHEMA.definitions.YardiVoyagerSystemSettingsSchema;
export const YARDI_VOYAGER_TRANSACTION_JSON_SCHEMA = _YARDI_VOYAGER_TRANSACTION_JSON_SCHEMA.definitions.YardiVoyagerTransactionSchema;
export const YARDI_VOYAGER_XML_JSON_SCHEMA = _YARDI_VOYAGER_XML_JSON_SCHEMA.definitions.YardiVoyagerXMLSchema;
